import { ImageThumb } from '@/shared/ui/ImageThumb';
import type { CategoryDto } from '../model/types';

export interface CategoryThumbProps {
  category: Pick<CategoryDto, 'name' | 'thumbUrl' | 'imageUrl'>;
  size?: number;
  /** Клик по миниатюре открывает фото крупно (в таблицах не нужен: клик там выделяет строку). */
  previewable?: boolean;
}

/** §2.1: миниатюра фото группы/категории; без фото — заглушка того же размера. */
export function CategoryThumb({ category, size = 20, previewable = false }: CategoryThumbProps) {
  return <ImageThumb src={category.thumbUrl} previewSrc={previewable ? category.imageUrl : null} size={size} alt={category.name} />;
}
